import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { ROSTER_NAME_COLUMN_ID, ROSTER_NAME_COLUMN_LABEL } from "./constants";
import { rosterColumnHeader } from "./header";
import { RosterCellValue } from "./roster-cell-value";
import type { ReadOnlyRosterRow } from "./types";

export const ReadOnlyNameCol = (
  width: number,
): ColumnDef<ReadOnlyRosterRow, unknown> => ({
  id: ROSTER_NAME_COLUMN_ID,
  header: rosterColumnHeader(ROSTER_NAME_COLUMN_LABEL),
  enableSorting: false,
  meta: { size: `${width}px` },
  cell: ({ row }) => (
    <Stack gap="none">
      <RosterCellValue value={row.original.member.display_name || "-"} />
      <Typography variant="bodyW3" textColor="tertiary" className="truncate">
        {row.original.member.service_titan_employee_id || "-"}
      </Typography>
    </Stack>
  ),
});
